// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"306":"e7a627e6","810":"9d1533c7","903":"14c1dea8","916":"e7a627e6"}[chunkId] + ".chunk.css";
};